import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function AboutColumbiaValleyWasteRecycling() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const residentialServices = [{
    id: 1,
    text: "Furniture"
  }, {
    id: 2,
    text: "Appliances"
  }, {
    id: 3,
    text: "Garage, basement, and attic cleanouts"
  }, {
    id: 4,
    text: "General household junk"
  }, {
    id: 5,
    text: "Single-item pickups"
  }];
  const estateServices = [{
    id: 1,
    text: "Estate cleanouts"
  }, {
    id: 2,
    text: "Foreclosure cleanouts"
  }, {
    id: 3,
    text: "Rental and tenant move-out"
  }, {
    id: 4,
    text: "Hoarder situations handled with care and discretion"
  }];
  const expectations = [{
    id: 2,
    text: "Upfront, transparent pricing"
  }, {
    id: 3,
    text: "Full-service removal (we do the heavy lifting)"
  }, {
    id: 4,
    text: "Thorough clean sweep-up after removal"
  }];
  return <section id="aboutcolumbiavalleywasterecycling" ref={ref} className="bg-surface py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <div className={`flex flex-col items-center text-center mb-12 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary mb-6 font-display tracking-tight">
            Columbia Valley Waste & Recycling - Junk Removal Services
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed max-w-3xl">
            We provide fast and reliable junk removal services across Calgary, Canmore, Invermere, and the entire Columbia Valley. Whether you're clearing out a single item or an entire property, our professional team is here to help you reclaim your space efficiently and responsibly.
          </p>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-2 gap-12 transition-all duration-700 delay-300 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="space-y-8">
            <div>
              <h3 className="text-2xl font-bold text-secondary mb-4">Residential Junk Removal</h3>
              <ul className="space-y-2">
                {residentialServices.map((item, i) => <li key={item.id} data-index={i} className="flex items-start text-muted-foreground">
                    <span className="mr-2 text-primary">•</span>
                    {item.text}
                  </li>)}
              </ul>
            </div>

            <div>
              <h3 className="text-2xl font-bold text-secondary mb-4">Property & Estate Cleanouts</h3>
              <ul className="space-y-2">
                {estateServices.map((item, i) => <li key={item.id} data-index={i} className="flex items-start text-muted-foreground">
                    <span className="mr-2 text-primary">•</span>
                    {item.text}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-white p-8 rounded-lg border border-muted/30 shadow-soft">
            <h3 className="text-2xl font-bold text-primary mb-6">What You Can Expect</h3>
            <ul className="space-y-4">
              {expectations.map((item, i) => <li key={item.id} data-index={i} className="flex items-start text-muted-foreground font-medium">
                  <span className="mr-3 text-accent"></span>
                  {item.text}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}